import Header from '../../components/header';
import Card from '../../components/Card';
import Sidebar from '../../components/sidebar/sidebar';
import ReportView from './ReportView';
import DownloadReport from './DownloadReport';
import Tab from './Tab';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Report = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine tab from path
  const getTabFromPath = () => {
    if (location.pathname.endsWith('/Download')) return 'Available Report';
    return 'Generate Report';
  };

  const [activeTab, setActiveTab] = useState(getTabFromPath());
  const tabs = ['Generate Report', 'Available Report'];

  // Sync tab with route
  useEffect(() => {
    setActiveTab(getTabFromPath());
  }, [location.pathname]);

  // Change route when tab changes
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    if (tab === 'Available Report') {
      navigate('/Report/Download');
    } else {
      navigate('/Report/Generate');
    }
  };

  return (
    <div className="flex">
      <Sidebar />
      <div className="bg-[var(--Background-Color,#000000)] flex-1">
        <Header title="Report" dropdown={2} />
        <Card className="flex-1" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <Tab tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />
          {activeTab === 'Available Report' ? <DownloadReport /> : <ReportView />}
        </Card>
      </div>
    </div>
  );
};

export default Report;
